import { atom } from "recoil";

export const ScheduleDateAtom = atom<Date | undefined>({
  key: "ScheduleDate",
  default: undefined,
});
